import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={103}
    height={200}
    viewBox="0 0 103 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity={0.3}>
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 4.97656)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 20.5498)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 36.124)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 51.6973)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 67.2715)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 82.8447)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 98.4189)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 113.993)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 129.566)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 145.141)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 160.714)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 176.288)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 5.71875 191.861)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 4.97656)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 20.5498)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 36.124)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 51.6973)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 67.2715)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 82.8447)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 98.4189)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 113.993)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 129.566)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 145.141)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 160.714)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.293 176.288)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 21.292 191.861)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 4.97656)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 20.5498)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 36.124)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 51.6973)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 67.2715)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 82.8447)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 98.4189)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 113.993)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 129.566)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 145.141)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 160.714)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 176.288)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 36.8662 191.861)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 4.97656)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 20.5498)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 36.124)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 51.6973)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 67.2715)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 82.8447)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 98.4189)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 113.993)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 129.566)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 145.141)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 160.714)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 176.288)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 52.4395 191.861)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 4.97656)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 20.5498)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 36.124)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 51.6973)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 67.2715)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 82.8447)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 98.4189)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 113.993)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 129.566)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 145.141)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 160.714)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 176.288)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 68.0137 191.861)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 4.97656)"
        fill="#CFD8DC"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 20.5498)"
        fill="#CFD8DC"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 36.124)"
        fill="#CFD8DC"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 51.6973)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 67.2715)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 82.8447)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 98.4189)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 113.993)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 129.566)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5869 145.141)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 160.714)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 176.288)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 83.5879 191.861)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 4.97656)"
        fill="#CFD8DC"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 20.5498)"
        fill="#CFD8DC"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 36.124)"
        fill="#CFD8DC"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 51.6973)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 67.2715)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 82.8447)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 98.4189)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 113.993)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 129.566)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 145.141)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 160.714)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 176.288)"
        fill="#FFE28A"
      />
      <circle
        cx={1.94672}
        cy={1.94672}
        r={1.94672}
        transform="matrix(-4.37114e-08 1 1 4.37114e-08 99.1611 191.861)"
        fill="#FFE28A"
      />
    </g>
  </svg>
);
export default SVGComponent;
